var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06011 11.1819L7.29234 12.9496C6.7297 13.5121 5.96669 13.828 5.17113 13.828C4.37557 13.8279 3.61261 13.5118 3.05007 12.9493C2.48752 12.3867 2.17145 11.6238 2.17139 10.8282C2.17132 10.0327 2.48725 9.26965 3.0497 8.707L4.81747 6.93924",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1821 9.06026L12.9499 7.2925C13.5123 6.72985 13.8282 5.96684 13.8282 5.17128C13.8281 4.37572 13.512 3.61277 12.9495 3.05022C12.387 2.48767 11.624 2.17161 10.8284 2.17154C10.0329 2.17147 9.26986 2.48741 8.70722 3.04986L6.93945 4.81762",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeLink);
export default __webpack_public_path__ + "static/media/de-link.f7ef11ccbbb26544785b80741bd83066.svg";
export { ForwardRef as ReactComponent };